import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AtelierService } from 'src/app/services/atelier-service';
import { SubscriptionBasedComponent } from 'src/app/subscription-helpers/subscription-based.component';
import { AtelierControllerService } from '../../service/atelier-controller.service';
import { AtelierTourItemHelper } from '../atelier-tour-item-helper';
import { AtelierDetailTourItem } from '../model/atelier-detail-tour-item';
import { AtelierUpdateCheckedResponse } from '../model/atelier-update-checked-response';
import { AtelierUpdateStockResponse } from '../model/atelier-update-stock-response';

@Component({
  selector: 'atelier-assignment-detail',
  templateUrl: './atelier-assignment-detail.component.html',
  styleUrls: ['./atelier-assignment-detail.component.scss'],
})
export class AtelierAssignmentDetailComponent
  extends SubscriptionBasedComponent
  implements OnInit
{
  @Input()
  tourId: number;
  @Input()
  reviewingUserId: number;
  @Input()
  atelierUserId: number;
  @Output()
  checkUpdate = new EventEmitter<AtelierUpdateCheckedResponse>();

  loading = false;
  items: AtelierDetailTourItem[];

  selectedItemId: number;

  constructor(
    private atelierControllerService: AtelierControllerService,
    private atelierTourItemHelper: AtelierTourItemHelper,
    private atelierService: AtelierService
  ) {
    super();
  }

  ngOnInit() {
    this.addSubscription(
      this.atelierService.getSelectedAtelierTourItemSubscribable(),
      (earlierStoredTourItemID) => {
        this.selectedItemId = earlierStoredTourItemID;
      }
    );
    this.fetchDetail();
  }

  updateSelectedItem(e: number) {
    this.atelierService.setSelectedAtelierTourItem(e);
  }

  fetchDetail(): void {
    this.loading = true;
    this.atelierControllerService
      .assignmentDetail(this.tourId)
      .then((res) => {
        this.items = this.parseItems(res);
      })
      .finally(() => (this.loading = false));
  }

  private parseItems(items: AtelierDetailTourItem[]): AtelierDetailTourItem[] {
    items.forEach((item) => {
      this.atelierTourItemHelper.parseItem(item);
    });

    return items;
  }

  onCheckUpdate(response: AtelierUpdateCheckedResponse): void {
    this.checkUpdate.emit(response);
  }

  onStockUpdate(response: AtelierUpdateStockResponse): void {
    this.items
      .filter(
        (item) =>
          item.subProject != null &&
          item.subProject.project.firstProduct != null &&
          item.subProject.project.firstProduct.signId === response.signId
      )
      .forEach((item) => {
        item.subProject.project.firstProduct.physicalStockRoofAmount =
          response.roofStock;
        item.subProject.project.firstProduct.physicalStockShelfAmount =
          response.shelfStock;
      });
  }
}
